import { Language } from "@types";
import { Locale } from "kz-ui-sdk";

export const STORAGE_KEY = {
  ACCESS_TOKEN: "token",
  //only remember phone while onboard
  //if switch tab the onboarding phone is still be passed to login/register component
  ONBOARDING_PHONE: "onboarding-phone",
  LANGUAGE: "lng",
  LANGUAGE_MANUAL: "lng-manual",
  MODE: "mode",
  OTP_TIMEOUT_PREFIX: "pk-",
  MARKETING_DATA: "mktg-data",
  REF_CODE: "ref-code",
  APP_UPDATE_AVAILABLE: "app-update-available",
  PAGE_CRASH_AUTO_RELOAD_COUNT: "page-crash-auto-reload-count",
  PAGE_CRASH_SENTRY_EVENT_ID: "page-crash-sentry-event-id",
  LOGIN_METHOD: "login-method",
  LOGIN_CRED_ID: "login-id",
  LOGIN_CRED_SECRET: "login-secret",
  LOGIN_PHONE: "login-phone",
  MEMBER_SETTINGS: "member-settings",
  PUBLIC_CONTACT_BANNERS: "public-contact-banners",
  PUBLIC_GROUPED_CONTACT_ICON: "public-grouped-contact-icon",
  PRIVATE_CONTACT_BANNERS: "private-contact-banners",
  PRIVATE_GROUPED_CONTACT_ICON: "private-grouped-contact-icon",
  MEGA_SHARE_SEEN_GIVER_TX_ID: "mega-share-seen-giver-tx-id",
  SECRET_CODE_SEEN_GIVER_CODE: "secret-code-seen-giver-code",
  CASHBACK_MISSION_COMPLETED: "cashback-mission-completed",
  EVENT_BADGE_STATE: "event-badges-state-v1",
  INFLIGHT_DEPOSITS: "kz:inflight-deposits",
  AUTO_ALLIANCE_BADGE_STATE: "auto-alliance-badges-state-v1",
  PROMOTION_PAGE_LANDED_COUNT: "promotion-page-landed-count",
  PENDING_DEPOSIT_METADATA: "pending-deposit-metadata",
  BANNER_CAROUSEL_FIRST_IMAGE: "banner-carousel-first-image",
  BEFORE_INSTALL_PROMPT_FIRED: "before-install-prompt-fired",
  PWA_REMINDER: "pwa-reminder",
  RECENT_GAMES_COUNT: "recent-games-count",
  MICRO_BANNER_COUNT: "micro-banner-count",
  FREE_BALLS_AUTO_DISPLAY_STATE: "free-balls-auto-display-state",
  DEPOSIT_NOTIFY_NUDGE_SHOWN: "deposit-notify-nudge-shown",
} as const;

// Cookies reach the installed app: Android shares them with Chrome, iOS copies them on Add to Home Screen
export const COOKIE_KEY = {
  REF_CODE: "__Host-ref-code",
  MARKETING_DATA: "__Host-mktg-data",
} as const;

export const PAGE_CRASH_MAX_AUTO_RELOAD_ATTEMPTS = 2;

export const LANGUAGES: Locale[] = [
  {
    code: Language.EN,
    displayName: "English",
    flagImage: {
      url: "/images/flags/flag-gb.svg",
    },
    sortPriority: 1,
  },
  {
    code: Language.TH,
    displayName: "ภาษาไทย",
    flagImage: {
      url: "/images/flags/flag-th.svg",
    },
    sortPriority: 2,
  },
  {
    code: Language.ID,
    displayName: "Bahasa Indonesia",
    flagImage: {
      url: "/images/flags/flag-id.svg",
    },
    sortPriority: 3,
  },
  {
    code: Language.BN,
    displayName: "বাংলা",
    flagImage: {
      url: "/images/flags/flag-bd.svg",
    },
    sortPriority: 4,
  },
  {
    code: Language.UR,
    displayName: "اردو",
    flagImage: {
      url: "/images/flags/flag-pk.svg",
    },
    sortPriority: 5,
  },
  {
    code: Language.TL,
    displayName: "Tagalog",
    flagImage: {
      url: "/images/flags/flag-ph.svg",
    },
    sortPriority: 6,
  },
  {
    code: Language.ES,
    displayName: "Español",
    flagImage: {
      url: "/images/flags/flag-mx.svg",
    },
    sortPriority: 7,
  },
  {
    code: Language.PT,
    displayName: "Português",
    flagImage: {
      url: "/images/flags/flag-br.svg",
    },
    sortPriority: 8,
  },
  {
    code: Language.HI,
    displayName: "हिन्दी",
    flagImage: {
      url: "/images/flags/flag-in.svg",
    },
    sortPriority: 9,
  },
  {
    code: Language.AR,
    displayName: "العربية",
    flagImage: {
      url: "/images/flags/flag-eg.svg",
    },
    sortPriority: 10,
  },
];

export const LANGUAGES_MAP: Record<Language, Locale> = {
  [Language.EN]: LANGUAGES[0],
  [Language.TH]: LANGUAGES[1],
  [Language.ID]: LANGUAGES[2],
  [Language.BN]: LANGUAGES[3],
  [Language.UR]: LANGUAGES[4],
  [Language.TL]: LANGUAGES[5],
  [Language.ES]: LANGUAGES[6],
  [Language.PT]: LANGUAGES[7],
  [Language.HI]: LANGUAGES[8],
  [Language.AR]: LANGUAGES[9],
};

export enum OnboardMode {
  LOGIN = "login",
  REGISTER = "register",
}

export const ACCESS_TOKEN_ENDPOINT = "/oauth/access_token";

export const DEFAULT_ERROR_MESSAGE = "an error occurred, please try again";

export const LINKED_TO_ANOTHER_ACCOUNT_ERROR_KEY = "already linked to another account";

export const DEFAULT_CONNECTION_ERROR_MESSAGE = "something went wrong. please try again.";

export enum NotificationDrawerEnabledStatus {
  ENABLED = "enabled",
  DISABLED = "disabled",
  LOADING = "loading",
}

export const ERROR_CODES = {
  FAILED_ALL_METHOD: "ERR100",
  MISSING_QR_CODE: "ERR101",
  MISSING_DATA_RESPONSE: "ERR102",
  TOP_UP_FAILED: "ERR103",
  MISSING_REDIRECT_DEPOSIT_URL: "ERR104",
  MISSING_NEW_WINDOW_DEPOSIT_URL: "ERR105",
  FUNDING_TX_NOT_FOUND: "ERR106",
} as const;
